export type TypedAnswerComparison = {
  correct: boolean;
  typed: Array<{ text: string; match: boolean }>;
  expected: Array<{ text: string; match: boolean }>;
};

export function compareTypedAnswer(typedValue: string, expectedValue: string): TypedAnswerComparison {
  const typed = normalizeAnswer(typedValue);
  const expected = normalizeAnswer(expectedValue);
  if (typed === expected) return {
    correct: true,
    typed: typed ? [{ text: typed, match: true }] : [],
    expected: expected ? [{ text: expected, match: true }] : [],
  };

  const left = Array.from(typed);
  const right = Array.from(expected);
  let prefix = 0;
  while (prefix < left.length && prefix < right.length && left[prefix] === right[prefix]) prefix += 1;
  let suffix = 0;
  while (suffix < left.length - prefix && suffix < right.length - prefix && left[left.length - 1 - suffix] === right[right.length - 1 - suffix]) suffix += 1;
  return {
    correct: false,
    typed: segments(left, prefix, suffix),
    expected: segments(right, prefix, suffix),
  };
}

function normalizeAnswer(value: string) {
  return value.normalize("NFKC").replace(/\s+/g, " ").trim();
}

function segments(characters: string[], prefix: number, suffix: number) {
  const result: Array<{ text: string; match: boolean }> = [];
  const before = characters.slice(0, prefix).join("");
  const different = characters.slice(prefix, suffix ? -suffix : undefined).join("");
  const after = suffix ? characters.slice(-suffix).join("") : "";
  if (before) result.push({ text: before, match: true });
  if (different) result.push({ text: different, match: false });
  if (after) result.push({ text: after, match: true });
  return result;
}
